"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z",
    id: "path7200"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 1.8093131,21.642369 h 8.0629632 c 0.2956447,0 0.5375307,-0.658915 0.5375307,-1.464254 V 17.16407 c 0,-0.805347 -0.241886,-1.464273 -0.5375307,-1.464273 H 1.8093131 c -0.2956416,0 -0.5375309,0.658926 -0.5375309,1.464273 v 3.014045 c 0,0.805339 0.2418893,1.464254 0.5375309,1.464254 z M 1.2717822,4.0711488 v 3.0140406 c 0,0.8053412 0.2418893,1.4642652 0.5375309,1.4642652 h 8.0629632 c 0.2956447,0 0.5375307,-0.658924 0.5375307,-1.4642652 V 4.0711488 c 0,-0.8053479 -0.241886,-1.4642691 -0.5375307,-1.4642691 H 1.8093131 c -0.2956416,0 -0.5375309,0.6589212 -0.5375309,1.4642691 z",
    id: "path7202",
    fill: "none",
    fillOpacity: "1",
    stroke: "currentColor",
    strokeWidth: "2.1555109",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.1555109",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "M 1.2647412,7.0574665 V 16.786236",
    id: "path7824"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "g8405",
    transform: "matrix(0.99154491,0,0,1.2034494,0.10105791,-2.1059077)",
    strokeWidth: "1.83088001",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "matrix(0.85769267,0,0,1.172624,0.04648561,-1.9512988)",
      strokeWidth: "1.82563791",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "g8377",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m 12.885058,10.155112 v 0.510197 c 0.0028,1.820129 0.04485,-0.9516832 0,2.176804 v 0.510195 c 0,0.489782 0.294693,0.605186 0.576788,0.34993 l 2.380264,-1.567585 c 0.21556,-0.141963 0.213471,-0.627547 0,-0.772766 L 13.492182,9.7632855 C 13.1613,9.5381946 12.885058,9.6653295 12.885058,10.15511 Z",
        id: "path7226",
        strokeWidth: "1.82563791",
        strokeMiterlimit: "4",
        strokeDasharray: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.82563791",
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: "4",
        strokeDasharray: "none",
        strokeOpacity: "1",
        d: "M 13.39162,11.703489 H 9.324072",
        id: "path8369"
      })]
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    fill: "none",
    fillOpacity: "1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeDashoffset: "0",
    strokeOpacity: "1",
    paintOrder: "normal",
    id: "rect8379",
    width: "7.7588243",
    height: "5.4383655",
    x: "15.004409",
    y: "9.1936359"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.09018719",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "M 2.2107091,12.091613 H 5.7164532",
    id: "path8389"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.09018719",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 16.823148,11.903341 h 4.033158",
    id: "path8391"
  })]
}));